import axios from "axios";
import { AxiosResponse } from "axios";
import { ApplicationDetails, Product } from "../context/DataContainerContext/types";


type ProductDataResponse = AxiosResponse<{
  success: boolean;
  data: Product[];
}>;

type ApplicationDataResponse = AxiosResponse<{
  data: ApplicationDetails;
}>;

const API_APPLICATION_DATA = process.env.REACT_APP_API_APPLICATION_DATA || "";
const API_KEY = process.env.REACT_APP_API_KEY || "";
const API_PRODUCTS_DATA = process.env.REACT_APP_API_PRODUCTS_DATA || "";
const APPLICATION_ID = process.env.REACT_APP_APPLICATION_ID || "";
const LOCALES_API = process.env.REACT_APP_LOCALES_API || "";
const IS_PROD_A = process.env.REACT_APP_IS_PROD_A === "true";
const IS_DEV = process.env.REACT_APP_IS_DEV === "true";

const getHeaders = () => ({
  "X-Header-ApiKey": API_KEY,
  "X-Header-AppId": APPLICATION_ID,
  ...(!IS_PROD_A && { "x-environment": "development" }),
  ...(IS_DEV && { "aws-cf-cd-onecx-cache": "disabled" }),
});

export function loadProductData(locale: string): Promise<ProductDataResponse> {
  return axios.get<ProductDataResponse["data"]>(API_PRODUCTS_DATA + locale, {
    headers: getHeaders(),
  });
}

export function loadApplicationData(
  locale: string
): Promise<ApplicationDataResponse> {
  return axios.get<ApplicationDataResponse["data"]>(
    API_APPLICATION_DATA + locale,
    {
      headers: getHeaders(),
    }
  );
}

export function getLocales() {
  return axios.get(LOCALES_API, {
    headers: getHeaders(),
  });
}
